import React, { useEffect, useState, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import api from "../services/api";

const QZ_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIECzCCAvOgAwIBAgIGAZy70fWdMA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG
EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS
UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx
HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg
RGVtbyBDZXJ0MB4XDTI2MDMwNDAyMjcwNVoXDTQ2MDMwNDAyMjcwNVowgaIxCzAJ
BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD
VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs
IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog
VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDy
BEjLPM5nHTgzlzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc
8I+KuhP+c7nm1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8
wJF4Mh9LcDv7DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRr
rT2ngVWgNdHxzX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/N
hQwBQ+Y1ICn/3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGH
uxPPeM9AaI24xaiJEMslAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD
VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQpIWj5KJSZl7tJTArHXlrHW4v9jTANBgkq
hkiG9w0BAQsFAAOCAQEAl7NpeyAlVvM6SkbCmkhFKZKTyOysA3smLz1E7eV5ZqQv
7mqZyIdWO6XJc9RWCOu21kZ765ADXnM/PvMHjHzKk1DeODwASFrlMaXPDskSad5g
ga/0k5r5NJse0Z+eUQZ4Ng1ZKRwLiblUuBxw87wxMQGp2jiOi/EQ0ZAoTW91F9bX
/6y2TA309JWAH5cFtZLs0HPtertJjoU2bDzk9Iz8exyJFS0WQsQzxU8Js0zr6d4N
loYITv0ymJ3TdOMomPYs7zVxAphUevg0ebCgC8+VI95kMDt5TadFsXHLJbl8rCD0
6wRUuC42VRXsVXuOUu8GXGchNgOcvqHW1YmtND+qMA==
-----END CERTIFICATE-----`;

const QZ_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDyBEjLPM5nHTgz
lzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc8I+KuhP+c7nm
1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8wJF4Mh9LcDv7
DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRrrT2ngVWgNdHx
zX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/NhQwBQ+Y1ICn/
3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGHuxPPeM9AaI24
xaiJEMslAgMBAAECggEASSLsUKbOhTC6VDTlIyzyegipsJHIIjYK39zY0T1QquhX
NQ2KPA2EoG5cq4F/4QexgA/egQDcm++jBVPaO9DSpB0er/rSFwodCkvnX5v2rH5c
rUqh45+OYqzKvE+rqMVauYVEMLuM44JGTgbPsysY6JgAw3C6DhwB1RfTSqy2HxPu
4CdSlaAqigE7ksPrBu04/av4OdtNQxElnojvEEqX6Qnimhj2kgd4GtROGlPYlBgc
vp9AQlAzStmLgJMp4zmObAq82/WVA4nFUlrdZT2zuKkxBGzPYdaChWhIW4NFpPUT
nWbWll1N0dk8ZMqiuzRBDyZjgiAYN/13W8qSPFIi/QKBgQD8gZ7tDXVQn4ds5Vhd
bmtnOk7fiFXTZLpKICDHW/pp8ou+eDdxALloAgdS1Ecp/f0hkjgAeuddcEki0qLP
TTRrD0ssq6NmoMtQHioIqqsRS5E7brPBqPAqHmTMOCXLI/UgfxOqghY2Zgg3RT0P
bD1ds8fx3oubO2Ha0Im21PJEUwKBgQD1XYJjKo8WqPpnYjSKp2OWxfDfYmDkRYIC
sq8PUqTiPsh+SGlU89lGrPF2DIq6EgvOnpUbVgqbz25GFkZLZQI3bpmDa+E+xEow
XjlnZKRPpNF3r7sTHJwqU6MIc55s2zyMx0UviwzHpLXidbKHWdfuvbyt/O1T+MAh
k5Ue17nDpwKBgG4H1ccajDp7qbmsHttn2Gl9IQ2LDUs2o27VnTMCQ5aTWI3BOPeH
B0PpTmOrmO8VfI56dujOpa8z1MrV2phW3jagzXNDv8pi2vWoj0yDglPhCAJL9Qy4
nx7ba7UJ6n4gxxpIBbvRP/iocYAULc1gr0T7qG8fONqF/9gn8zq2hHN9AoGBAL27
ChkOjsjR75dD7CcPWsX619CUrSG20dquOwoZOOCt9bEY40JKsUeicbB78EYDsFec
buZNeTSUiMvva3nfaIBeqJxkLi+v70JJig/2Vcw0QblQDNOxetyMAfSGGwpH2SFu
8YPa/Q3fwrmTk3JwObYlx6GuhAI7xq3wBg5sd/vfAoGBAMtMIh0VnTnFXBbLQ0bz
BAM4fY5xjbwCUDm2HJzsuZ8w5b9H69Ogh7hG9gk/XaBP7jbk+3icbmo03cowwXyF
FfoAOlcPBgHqvut1n9UH37WRF/vcsup81rQjqgS/s8TPKG9fmbuRgPJ2ALjStTB4
9qLkf2Fe9mvvdHK4m+TgsBjO
-----END PRIVATE KEY-----`;

const ESC = '\x1B';
const GS  = '\x1D';
const CMD = {
  INIT:         ESC + '@',
  ALIGN_LEFT:   ESC + 'a\x00',
  ALIGN_CENTER: ESC + 'a\x01',
  ALIGN_RIGHT:  ESC + 'a\x02',
  BOLD_ON:      ESC + 'E\x01',
  BOLD_OFF:     ESC + 'E\x00',
  SIZE_NORMAL:  GS  + '!\x00',
  SIZE_WIDE:    GS  + '!\x10',
  CUT:          GS  + 'V\x41\x03',
  FEED:         ESC + 'd\x04',
  LF:           '\n',
};

const trunc = (text, max) => { const s = String(text ?? ''); return s.length > max ? s.substring(0, max-1) + '.' : s; };
const rowLR = (left, right, width = 48) => { const l = String(left); const r = String(right); const sp = width - l.length - r.length; return l + (sp > 0 ? ' '.repeat(sp) : ' ') + r; };
const separator = (char = '-', width = 48) => char.repeat(width);

const generarESCPOS = (invoice, company) => {
  const sale    = invoice;
  const fel     = invoice.invoice;
  const client  = invoice.client ?? {};
  const details = invoice.sale_details ?? invoice.saleDetails ?? [];
  const efectivo = Number(invoice.cash ?? sale.cash ?? sale.efectivo ?? 0);
  const cambio   = Number(invoice.change ?? sale.change ?? sale.cambio ?? 0);
  const numeroControl = fel?.numero_control ?? 'N/A';
  const codigoGen     = fel?.codigo_generacion ?? '';
  const sello         = fel?.sello_recepcion ?? '';
  const fecha         = fel?.fecha_emision ?? new Date().toLocaleDateString();
  const tipoDoc       = fel?.tipo_documento || sale?.tipo_documento || '01';
  const esCF          = tipoDoc === '03';
  const tituloDoc     = esCF ? 'CREDITO FISCAL' : 'CONSUMIDOR FINAL';

  let c = '';
  c += CMD.INIT;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + 'EMISOR' + CMD.LF;
  c += CMD.SIZE_WIDE + (company?.nombre_comercial || company?.nombre || 'EMPRESA') + CMD.LF;
  c += CMD.SIZE_NORMAL + CMD.BOLD_OFF;
  if (company?.nombre) c += CMD.ALIGN_CENTER + company.nombre + CMD.LF;
  c += CMD.ALIGN_LEFT;
  if (company?.nit)            c += 'NIT: ' + company.nit + CMD.LF;
  if (company?.nrc)            c += 'NRC: ' + company.nrc + CMD.LF;
  if (company?.desc_actividad) c += 'Act: ' + trunc(company.desc_actividad, 42) + CMD.LF;
  if (company?.direccion)      c += 'Dir: ' + trunc(company.direccion, 42) + CMD.LF;
  if (company?.telefono)       c += 'Tel: ' + company.telefono + CMD.LF;
  if (company?.email)          c += 'Email: ' + trunc(company.email, 38) + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + 'DOCUMENTO TRIBUTARIO ELECTRONICO' + CMD.LF + tituloDoc + CMD.LF + CMD.BOLD_OFF;
  c += CMD.ALIGN_LEFT + separator() + CMD.LF;
  c += 'Num. Control:' + CMD.LF + trunc(numeroControl, 48) + CMD.LF;
  c += 'Cod. Generacion:' + CMD.LF + trunc(codigoGen, 48) + CMD.LF;
  if (sello) c += 'Sello:' + CMD.LF + trunc(sello, 48) + CMD.LF;
  c += 'Fecha: ' + fecha + CMD.LF;
  c += separator() + CMD.LF;
  c += rowLR('Cajero:', sale?.cajero ?? 'Sistema') + CMD.LF;
  c += rowLR('Caja:', sale?.caja ?? 'Caja 1') + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + 'CLIENTE' + CMD.BOLD_OFF + CMD.LF;
  c += (client?.nombre || 'Cliente General') + CMD.LF;
  if (esCF) {
    if (client?.nit || client?.numero_documento || client?.num_documento) c += 'NIT: ' + (client.nit || client.numero_documento || client.num_documento) + CMD.LF;
    if (client?.nrc) c += 'NRC: ' + client.nrc + CMD.LF;
    if (client?.desc_actividad || client?.giro) c += 'Giro: ' + trunc(client.desc_actividad || client.giro, 42) + CMD.LF;
    if (client?.direccion) c += 'Dir: ' + trunc(client.direccion, 42) + CMD.LF;
  }
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + 'Descripcion              Cant  P.U.    Total' + CMD.LF + CMD.BOLD_OFF;
  c += separator('-') + CMD.LF;
  details.forEach(item => {
    const nombre = trunc(item.nombre_producto_snapshot ?? item.product?.nombre ?? 'Producto', 24);
    const cant   = Number(item.cantidad);
    const precio = Number(item.precio_unitario_snapshot ?? 0);
    const total  = cant * precio;
    c += nombre + CMD.LF;
    c += CMD.ALIGN_RIGHT + cant + '  $' + precio.toFixed(2) + '  $' + total.toFixed(2) + CMD.LF;
    c += CMD.ALIGN_LEFT;
  });
  c += separator() + CMD.LF;
  c += CMD.BOLD_ON + CMD.SIZE_WIDE + rowLR('TOTAL:', '$' + Number(sale?.monto_final ?? 0).toFixed(2), 24) + CMD.LF;
  c += CMD.SIZE_NORMAL + CMD.BOLD_OFF;
  if (sale?.monto_letras) c += trunc(sale.monto_letras, 48) + CMD.LF;
  c += separator() + CMD.LF;
  c += rowLR('Efectivo:', '$' + efectivo.toFixed(2)) + CMD.LF;
  c += CMD.BOLD_ON + rowLR('Cambio:', '$' + cambio.toFixed(2)) + CMD.BOLD_OFF + CMD.LF;
  c += separator() + CMD.LF;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON + '*** GRACIAS POR SU COMPRA ***' + CMD.LF + CMD.BOLD_OFF;
  c += 'Conserve este documento para reclamos' + CMD.LF;
  if (codigoGen) {
    c += separator() + CMD.LF;
    c += CMD.ALIGN_CENTER + 'Escanee para descargar PDF y JSON' + CMD.LF;
  }
  c += CMD.FEED;
  return c;
};

export default function Ticket({ invoice, onAfterPrint }) {
  const [company, setCompany] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);
  const ticketRef = useRef(null);

  // ── useEffect 1: cargar datos de empresa ──
  useEffect(() => {
    console.log('🔍 Cargando datos de empresa...');
    api.get('/company/info')
      .then(r => {
        console.log('✅ Datos de empresa recibidos:', r.data);
        setCompany(r.data);
        setIsReady(true);
      })
      .catch(err => {
        console.error('❌ Error cargando datos de empresa:', err);
        setError(err.message);
        setCompany({ nombre: "EMPRESA DEMO", direccion: "Dirección no disponible", telefono: "0000-0000", email: "info@empresa.com", nit: "0000-000000-000-0", nrc: "000000-0" });
        setIsReady(true);
      });
  }, []);

  // ── useEffect 2: conectar QZ Tray al cargar la pagina ──
  useEffect(() => {
    const qz = window.qz;
    if (!qz) { console.warn('QZ Tray no disponible'); return; }

    qz.security.setCertificatePromise(function(resolve, reject) {
      resolve(QZ_CERTIFICATE);
    });
    qz.security.setSignatureAlgorithm('SHA512');
    qz.security.setSignaturePromise(function(toSign) {
      return function(resolve, reject) {
        const pemBody = QZ_PRIVATE_KEY
          .replace(/-----BEGIN PRIVATE KEY-----/, '')
          .replace(/-----END PRIVATE KEY-----/, '')
          .replace(/\s+/g, '');
        const binaryStr = atob(pemBody);
        const keyBuffer = new Uint8Array(binaryStr.length);
        for (let i = 0; i < binaryStr.length; i++) keyBuffer[i] = binaryStr.charCodeAt(i);
        window.crypto.subtle.importKey('pkcs8', keyBuffer.buffer, { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-512' } }, false, ['sign'])
          .then(function(cryptoKey) {
            return window.crypto.subtle.sign({ name: 'RSASSA-PKCS1-v1_5' }, cryptoKey, new TextEncoder().encode(toSign));
          })
          .then(function(signature) {
            resolve(btoa(String.fromCharCode(...new Uint8Array(signature))));
          })
          .catch(reject);
      };
    });

    qz.websocket.connect()
      .then(function() { console.log('QZ listo!'); })
      .catch(function(e) { console.error('QZ error:', e); });
  }, []);

  // ── useEffect 3: imprimir cuando llega la factura ──
  useEffect(() => {
    if (!invoice || !isReady) return;

    console.log('EJECUTANDO IMPRESION', invoice, isReady);
    const timer = setTimeout(async () => {
      try {
        const qz = window.qz;

        if (!qz) throw new Error('QZ Tray no disponible');

        // Reconectar si la conexion se cerro
        if (!qz.websocket.isActive()) {
          console.log('Reconectando QZ...');
          await qz.websocket.connect();
        }

        const impresora = await qz.printers.getDefault();
        console.log('Imprimiendo en:', impresora);

        const datos = [{ type: 'raw', format: 'command', data: generarESCPOS(invoice, company) }];

        if (invoice?.invoice?.codigo_generacion) {
          const originalCanvas = document.querySelector('.ticket-qr canvas');
          if (originalCanvas) {
            const canvas = document.createElement('canvas');
            const scale = 1.9;
            canvas.width = originalCanvas.width * scale;
            canvas.height = originalCanvas.height * scale;
            const ctx2 = canvas.getContext('2d');
            ctx2.drawImage(originalCanvas, 0, 0, canvas.width, canvas.height);
            const w = canvas.width;
            const h = canvas.height;
            const imageData = ctx2.getImageData(0, 0, w, h);
            const bytesPerRow = Math.ceil(w / 8);
            let bmp = '';
            bmp += GS + 'v0' + '\x00';
            bmp += String.fromCharCode(bytesPerRow & 0xff, (bytesPerRow >> 8) & 0xff);
            bmp += String.fromCharCode(h & 0xff, (h >> 8) & 0xff);
            for (let y = 0; y < h; y++) {
              for (let bx = 0; bx < bytesPerRow; bx++) {
                let byte = 0;
                for (let bit = 0; bit < 8; bit++) {
                  const x = bx * 8 + bit;
                  if (x < w) {
                    const idx = (y * w + x) * 4;
                    const brightness = imageData.data[idx] * 0.299 + imageData.data[idx+1] * 0.587 + imageData.data[idx+2] * 0.114;
                    if (brightness < 128) byte |= (0x80 >> bit);
                  }
                }
                bmp += String.fromCharCode(byte);
              }
            }
            datos.push({ type: 'raw', format: 'command', data: CMD.ALIGN_CENTER + bmp });
          }
        }

        datos.push({ type: 'raw', format: 'command', data: CMD.FEED + CMD.CUT });

        await qz.print(qz.configs.create(impresora), datos);
        console.log('Impresion enviada correctamente');

      } catch (err) {
        console.error('Error QZ:', err);
        // Fallback: imprimir con window.print()
        const details = invoice.sale_details ?? invoice.saleDetails ?? [];
        const baseHeight = 280;
        const heightPerItem = 10;
        const totalHeight = baseHeight + (details.length * heightPerItem);
        const styleId = 'dynamic-page-size';
        let style = document.getElementById(styleId);
        if (!style) { style = document.createElement('style'); style.id = styleId; document.head.appendChild(style); }
        style.innerHTML = `@page { size: 80mm ${totalHeight}mm; margin: 0; }`;
        window.print();
      }

      if (onAfterPrint) onAfterPrint();
    }, 1500);

    return () => clearTimeout(timer);
  }, [invoice, isReady, company, onAfterPrint]);

  if (!invoice || !isReady) return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', fontSize:'18px' }}>
      Cargando...
    </div>
  );

  const sale = invoice;
  const fel = invoice.invoice;
  const client = invoice.client ?? {};
  const details = invoice.sale_details ?? invoice.saleDetails ?? [];
  const efectivo = invoice.cash ?? sale.cash ?? sale.efectivo ?? 0;
  const cambio = invoice.change ?? sale.change ?? sale.cambio ?? 0;
  const numeroControl = fel?.numero_control;
  const tipoDocumento = fel?.tipo_documento || sale?.tipo_documento || "01";
  const esCreditoFiscal = tipoDocumento === "03";
  const esConsumidorFinal = tipoDocumento === "01";

  const obtenerTituloDocumento = () => {
    if (esCreditoFiscal) return "CRÉDITO FISCAL";
    if (esConsumidorFinal) return "CONSUMIDOR FINAL";
    return "FACTURA";
  };

  const obtenerNombreTipoDocumento = (codigo) => {
    const tipos = { '36':'NIT','13':'DUI','37':'Otro','03':'Pasaporte','02':'Carnet de Residente' };
    return tipos[codigo] || 'Documento';
  };

  return (
    <>
      <style>
        {`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { background: #f7fafc; }
        .ticket-wrapper { display: flex; justify-content: center; align-items: center; min-height: 100vh; padding: 20px; }
        .ticket { width: 80mm; font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #000; background: white; padding: 8mm; box-shadow: 0 4px 12px rgba(0,0,0,0.15); margin: 0 auto; }
        .ticket-center { text-align: center; }
        .ticket-company { font-weight: bold; font-size: 14px; margin-bottom: 6px; }
        .ticket-info { font-size: 10px; line-height: 1.4; }
        .ticket-info-line { margin: 2px 0; }
        .ticket-divider { border: none; border-top: 1px dashed #000; margin: 10px 0; }
        .ticket-section-title { font-weight: bold; font-size: 13px; text-align: center; margin: 10px 0 6px 0; }
        .ticket-row { display: flex; justify-content: space-between; margin: 4px 0; font-size: 11px; }
        .ticket-row-bold { font-weight: bold; }
        .ticket-table-header { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; font-weight: bold; border-bottom: 1px solid #000; padding-bottom: 4px; margin-bottom: 6px; font-size: 10px; }
        .ticket-table-row { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; margin: 4px 0; font-size: 10px; }
        .ticket-table-cell { text-align: right; }
        .ticket-table-cell:first-child { text-align: left; }
        .ticket-total { font-size: 15px; font-weight: bold; margin: 10px 0; }
        .ticket-qr { text-align: center; margin: 12px 0; }
        .ticket-footer { text-align: center; margin-top: 12px; }
        .text-small { font-size: 10px; }
        .text-bold { font-weight: bold; }
        .error-badge { background-color: #fee; border: 1px solid #fcc; padding: 8px; margin-bottom: 10px; border-radius: 4px; font-size: 10px; color: #c00; }
        .qz-badge { background: #d1fae5; border: 1px solid #6ee7b7; padding: 4px 8px; border-radius: 4px; font-size: 10px; color: #065f46; text-align: center; margin-bottom: 8px; }
        @media print {
          * { visibility: hidden; }
          .ticket-wrapper, .ticket-wrapper * { visibility: visible; }
          html, body { margin: 0 !important; padding: 0 !important; background: white !important; overflow: visible !important; }
          .ticket-wrapper { position: absolute; left: 0; top: 0; width: 80mm; padding: 0; margin: 0; }
          .ticket { box-shadow: none; margin: 0; padding: 5mm; width: 80mm; font-size: 14px; }
          .ticket-company { font-size: 17px; }
          .ticket-info { font-size: 12px; }
          .ticket-section-title { font-size: 15px; }
          .ticket-row { font-size: 13px; }
          .ticket-table-header { font-size: 12px; }
          .ticket-table-row { font-size: 12px; }
          .ticket-total { font-size: 17px; }
          .text-small { font-size: 12px; }
          .error-badge, .qz-badge { display: none; }
        }
        `}
      </style>

      <div className="ticket-wrapper">
        <div className="ticket" ref={ticketRef}>

          <div className="qz-badge">✅ Impresión directa activa (ESC/POS)</div>

          {error && (
            <div className="error-badge">
              ⚠️ No se pudieron cargar los datos de la empresa. Usando datos por defecto.
            </div>
          )}

          <div className="ticket-center">
            <div className="ticket-section-title" style={{ marginTop: 0 }}>EMISOR</div>
            <div className="ticket-company">
              {company?.nombre_comercial || company?.nombre || 'NOMBRE DE EMPRESA'}
            </div>
            <div className="ticket-info" style={{ marginBottom: '4px' }}>
              <div className="ticket-info-line">{company?.nombre || ''}</div>
            </div>
            <div className="ticket-info">
              <div className="ticket-info-line"><strong>NIT:</strong> {company?.nit || 'N/A'}</div>
              <div className="ticket-info-line"><strong>NRC:</strong> {company?.nrc || 'N/A'}</div>
              {company?.desc_actividad && (
                <div className="ticket-info-line">
                  <strong>Actividad Económica:</strong>
                  <div>{company.desc_actividad}</div>
                </div>
              )}
              <div className="ticket-info-line"><strong>Dirección:</strong> {company?.direccion || 'N/A'}</div>
              <div className="ticket-info-line"><strong>Tel:</strong> {company?.telefono || 'N/A'}</div>
              <div className="ticket-info-line"><strong>Email:</strong> {company?.email || 'N/A'}</div>
            </div>
          </div>

          <hr className="ticket-divider" />

          <div className="ticket-section-title">DOCUMENTO TRIBUTARIO ELECTRÓNICO</div>
          <div className="ticket-center">
            <div className="text-bold" style={{ fontSize: '14px' }}>{obtenerTituloDocumento()}</div>
          </div>

          <hr className="ticket-divider" />

          <div className="text-small">
            <div><strong>Número Control:</strong></div>
            <div style={{ wordBreak: 'break-all', marginBottom: '4px' }}>{numeroControl || 'N/A'}</div>
            <div><strong>Código Generación:</strong></div>
            <div style={{ wordBreak: 'break-all', marginBottom: '4px' }}>{fel?.codigo_generacion || 'N/A'}</div>
            {fel?.sello_recepcion && (
              <>
                <div><strong>Sello de Recepción:</strong></div>
                <div style={{ wordBreak: 'break-all', marginBottom: '4px' }}>{fel.sello_recepcion}</div>
              </>
            )}
            <div><strong>Fecha:</strong> {fel?.fecha_emision || new Date().toLocaleDateString()}</div>
          </div>

          <hr className="ticket-divider" />

          <div className="ticket-row">
            <span><strong>Cajero:</strong></span>
            <span>{sale?.cajero ?? "Sistema"}</span>
          </div>
          <div className="ticket-row">
            <span><strong>Caja:</strong></span>
            <span>{sale?.caja ?? "Caja 1"}</span>
          </div>

          <hr className="ticket-divider" />

          <div className="text-bold" style={{ marginBottom: '4px' }}>CLIENTE</div>

          {esConsumidorFinal ? (
            <div>{client?.nombre || 'Cliente General'}</div>
          ) : (
            <div>
              <div><strong>Nombre:</strong> {client?.nombre || 'Cliente General'}</div>
              {(client?.numero_documento || client?.nit || client?.num_documento) && (
                <div><strong>{obtenerNombreTipoDocumento(client.tipo_documento)}:</strong> {client.numero_documento || client.nit || client.num_documento}</div>
              )}
              {client?.nrc && <div><strong>NRC:</strong> {client.nrc}</div>}
              {(client?.desc_actividad || client?.giro) && <div><strong>Giro:</strong> {client.desc_actividad || client.giro}</div>}
              {client?.direccion && <div style={{ fontSize: '10px', marginTop: '4px' }}><strong>Dirección:</strong> {client.direccion}</div>}
              {client?.telefono && <div><strong>Tel:</strong> {client.telefono}</div>}
              {(client?.correo || client?.email) && <div><strong>Email:</strong> {client.correo || client.email}</div>}
            </div>
          )}

          <hr className="ticket-divider" />

          <div className="ticket-table-header">
            <div>Descripción</div>
            <div className="ticket-table-cell">Cant.</div>
            <div className="ticket-table-cell">P.U.</div>
            <div className="ticket-table-cell">Total</div>
          </div>

          {details.length === 0 && (
            <div className="ticket-center text-small">No hay productos</div>
          )}

          {details.map((item, i) => (
            <div key={i} className="ticket-table-row">
              <div>{item.nombre_producto_snapshot ?? item.product?.nombre ?? "Producto"}</div>
              <div className="ticket-table-cell">{item.cantidad}</div>
              <div className="ticket-table-cell">${Number(item.precio_unitario_snapshot ?? 0).toFixed(2)}</div>
              <div className="ticket-table-cell">${(Number(item.cantidad) * Number(item.precio_unitario_snapshot ?? 0)).toFixed(2)}</div>
            </div>
          ))}

          <hr className="ticket-divider" />

          <div className="ticket-row ticket-total">
            <span>TOTAL:</span>
            <span>${Number(sale?.monto_final ?? 0).toFixed(2)}</span>
          </div>

          {sale?.monto_letras && (
            <div className="ticket-center text-small" style={{ marginTop: '6px' }}>{sale.monto_letras}</div>
          )}

          <hr className="ticket-divider" />

          <div className="ticket-row">
            <span>Efectivo Recibido:</span>
            <span>${Number(efectivo).toFixed(2)}</span>
          </div>
          <div className="ticket-row ticket-row-bold">
            <span>Cambio:</span>
            <span>${Number(cambio).toFixed(2)}</span>
          </div>

          <hr className="ticket-divider" />

          {fel?.codigo_generacion && (
            <div className="ticket-qr">
              <QRCodeCanvas
                value={`${process.env.REACT_APP_URL || "https://altivaweb.com/FACTURACION/BACK/public"}/factura/${fel.codigo_generacion}`}
                size={140}
                level="M"
                includeMargin={true}
              />
              <div className="text-small" style={{ marginTop: '8px' }}>
                Escanee para descargar PDF y JSON
              </div>
            </div>
          )}

          <hr className="ticket-divider" />

          <div className="ticket-footer text-bold" style={{ fontSize: '13px' }}>¡GRACIAS POR SU COMPRA!</div>
          <div className="ticket-footer text-small" style={{ marginTop: '6px' }}>Conserve este documento para cualquier reclamo</div>

        </div>
      </div>
    </>
  );
}